<div class="row text-left justify-content-md-center mt-5">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title" id="basic-layout-form">{{ 'account.resetPassword.title' | translate }}</h4>
        <p class="mb-0">{{ 'account.resetPassword.text' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="px-3">
          <form class="form" #resetPasswordForm="ngForm" (ngSubmit)="onSubmit(resetPasswordForm)">
            <h4 class="form-section"><i class="ft-cpu"></i> {{ 'account.resetPassword.detailsHeader' | translate }}</h4>
            <div class="form-group">
              <input type="hidden" class="form-control" name="Email" id="Email" #Email="ngModel" placeholder="Email"
                     [(ngModel)]="resetPassword.Email" required>
            </div>
            <div class="form-group">
              <input type="hidden" class="form-control" name="Code" #Code="ngModel" placeholder="Code"
                     [(ngModel)]="resetPassword.Code" required>
            </div>
            <div class="form-group">
              <label for="Password">{{ 'account.resetPassword.newPasswordFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-lock"></i>
                  </span>
                </div>
                <input type="password" id="Password" class="form-control" name="Password" #Password="ngModel"
                       placeholder="{{'account.resetPassword.newPasswordFieldPlaceHolder' | translate}}"
                       autocomplete="new-password"
                       [(ngModel)]="resetPassword.Password" required minlength="8" [ngModelOptions]="{updateOn: 'blur'}"
                       pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_.,/?;:+=!*()@%&]).{8,}$"/>

              </div>
              <small class="form-text text-muted danger"
                     *ngIf="!Password.valid && (Password.dirty || Password.touched)">
                {{ 'account.resetPassword.newPasswordInformationText' | translate }}
              </small>
            </div>
            <div class="form-group">
              <label for="ConfirmPassword">{{ 'account.resetPassword.confirmPasswordFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="ft-lock"></i>
                  </span>
                </div>
                <input type="password" id="ConfirmPassword" class="form-control" name="ConfirmPassword" #ConfirmPassword="ngModel"
                       placeholder="{{'account.resetPassword.confirmPasswordFieldPlaceHolder' | translate}}"
                       autocomplete="new-password"
                       [(ngModel)]="resetPassword.ConfirmPassword" required minlength="8"/>
              </div>
              <small class="form-text text-muted danger"
                     *ngIf="(ConfirmPassword.dirty || ConfirmPassword.touched) && (resetPassword.Password != resetPassword.ConfirmPassword)">
                {{ 'account.resetPassword.confirmPasswordInformationText' | translate }}
              </small>
            </div>
            <div class="form-group text-center">
              <button type="submit" class="btn btn-primary btn-raised mr-1" [disabled]="!resetPasswordForm.valid">
                <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
